import React, { useState, useEffect } from 'react'
import { COLORES } from '../../../../config/colores'
import { Dialog, Button } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import CantidadProductosPorCereal from '../../components/reporteCamiones/CantidadProductosPorCereal'
import TablaCamionesEnPlaya from '../../../Camiones/containers/listados/camionesEnPlaya/containers/TablaCamionesEnPlaya'
import InfoCantidadAdicional from '../../components/reporteCamiones/InfoCantidadAdicional'

function ReporteCamionesEnPlaya (props) {
  const { camionesEnPlaya } = props
  const [open, setOpen] = useState(false)
  const [totalProductos, setTotalProductos] = useState(null)
  const [totalPenalizados, setTotalPenalizados] = useState(null)
  const [productosPenalizados, setProductosPenalizados] = useState(null)
  const [productosPorCereal, setProductosPorCereal] = useState([])

  useEffect(() => {
    function setUp () {
      if (camionesEnPlaya && camionesEnPlaya.filas_procesadas > 0) {
        const total = camionesEnPlaya.filas_procesadas
        const penalizados = []
        let cantidad = 0

        const camsEnPlaya = camionesEnPlaya.filas
        setTotalProductos(total)
        const productos = []
        const productosListos = camsEnPlaya.reduce((prod, camion) => {
          const { claveCereal, penalizado } = camion
          const productoExistente = productos.find(producto => producto.cereal === claveCereal)
          const existePenalizado = penalizados.find(p => p.cereal === claveCereal)

          if (!penalizado) {
            if (!productoExistente) {
              const cantidad = camsEnPlaya.filter((p) => p.claveCereal === claveCereal && !p.penalizado)
              productos.push({ cereal: claveCereal, cantidad: cantidad.length })
            }
          } else {
            if (!existePenalizado) {
              penalizados.push({ cereal: claveCereal, cantidad: 1 })
            } else {
              existePenalizado.cantidad += 1
            }
            cantidad = +1
          }
          return productos
        }, [])

        setTotalPenalizados(cantidad)
        setProductosPenalizados(penalizados)
        setProductosPorCereal(productosListos)
        productosListos.sort((a, b) => {
          return a.cereal.localeCompare(b.cereal)
        })
      }
    }

    setUp()
  }, [camionesEnPlaya])

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='xl'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Camiones en playa'
          content={<TablaCamionesEnPlaya />}
        />
      </Dialog>

      <CantidadProductosPorCereal
        productosPorCereal={productosPorCereal}
        titulo='En playa'
        tituloTotal='Total en playa'
        totalProductos={totalProductos}
        cortes
      />
      {productosPenalizados && <InfoCantidadAdicional
        productos={productosPenalizados}
        titulo='Camiones penalizados'
        cantidad={totalPenalizados}
      />
      }
      <Button
        size='small'
        className='btn-reportes-bruto'
        variant='contained'
        style={{ color: '#ffffff', backgroundColor: COLORES.grey.dark, borderRadius: '22px', margin: '0 auto' }}
        onClick={handleOpen}
      >
                Camiones en playa
      </Button>
    </>
  )
}

export default ReporteCamionesEnPlaya
